import React from 'react';
import PropTypes from 'prop-types';
import {
  Components, Theme, Utils, translate,
} from 'versafleet-core';
import { connect } from 'react-redux';
import moment from 'moment';

function getStatusIcon(data) {
  let dividerColor;

  switch (data.state) {
    case 'draft':
      dividerColor = Theme.Color.$bluedarker;
      break;
    case 'submitted':
      dividerColor = Theme.Color.$gold;
      break;
    case 'cancelled':
    case 'rejected':
      dividerColor = Theme.Color.$red;
      break;
    case 'completed':
      dividerColor = Theme.Color.$green;
      break;
    case 'ongoing':
    case 'in_progress':
      dividerColor = Theme.Color.$green;
      break;
    case 'pending':
      dividerColor = Theme.Color.$gold;
      break;
    default:
  }

  return (
    <Components.Mobile.Divider
      color={dividerColor}
    />
  );
}

class JobDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAttachmentInput: false,
    };
  }

  _routeToTaskDetails = (taskId) => {
    let path = '';
    const currentPaths = Utils.Router.getPath().split('/').filter(v => v !== '');
    for (let j = 0; j < currentPaths.length; j += 1) {
      if (currentPaths[j] === 'tasks' || currentPaths[j] === 'jobs') {
        break;
      }
      path += `/${currentPaths[j]}`;
    }

    path += `/tasks/${taskId}`;
    Utils.Router.transitionTo(path);
  }

  _renderAdditionalInfo() {
    if (!this.props.myjobsSetting.show_additional_info) {
      return false;
    }

    return (
      <Components.Form.ExpandableContainer
        parent={(
          <Components.Form.Block fontWeight="BOLD" iconClassName="versa-subject" level={0}>
            {this.props.strings.Job.form.additionalInfo.title}
          </Components.Form.Block>
        )}
      >
        <Components.Form.Divider />

        {this.props.myjobsSetting.show_note ? [(
          <Components.Form.Block
            className="vf-job__view-form__additional-info__remarks"
            iconClassName="versa-note"
            level={1}
          >
            {this.props.data.remarks || this.props.strings.Job.form.additionalInfo.noRemarks}
          </Components.Form.Block>
        ), (
          <Components.Form.Divider />
        )] : false}

        {this.props.myjobsSetting.show_tags ? [(
          <Components.Form.Block iconClassName="versa-tags" level={1}>
            <Components.Tags
              tags={(this.props.data.tags || []).map(tag => tag.name).filter(tag => tag !== 'Point-to-Point')}
            />
          </Components.Form.Block>
        ), (
          <Components.Form.Divider />
        )] : false}

        <Components.Form.Block iconClassName="versa-attachment" level={1}>
          {Utils.UserAgentDetector.isMobileOrTablet() ? (
            <Components.Form.MobileAttachmentInput
              apiUrl={process.env.apiUrl}
              editable={false}
              id={`${this.props.id}__mobile-attachment-input`}
              onButtonClick={() => this.setState({ openAttachmentInput: true })}
              onClose={() => this.setState({ openAttachmentInput: false })}
              open={this.state.openAttachmentInput}
              value={this.props.data.attachments}
            />
          ) : (
            <Components.Form.AttachmentInput
              apiUrl={process.env.apiUrl}
              editable={false}
              id={`${this.props.id}__attachment-input`}
              onButtonClick={() => this.setState({ openAttachmentInput: true })}
              onClose={() => this.setState({ openAttachmentInput: false })}
              open={this.state.openAttachmentInput}
              value={this.props.data.attachments}
            />
          )}
        </Components.Form.Block>
      </Components.Form.ExpandableContainer>
    );
  }

  render() {
    if (Utils.Helper.isNullOrUndefined(this.props.data)) {
      return false;
    }

    const allowAddTask = (data) => {
      const isP2P = (data.job_type === 'p2p' || (data.job_type === 'delivery' && data.tags && data.tags.filter(tag => tag.name === 'Point-to-Point').length > 0));
      return !data.archived && !(isP2P && (data.tasks || []).length > 0) && (
        data.state !== 'submitted' && data.state !== 'in_progress' && data.state !== 'completed'
      );
    };

    const stringsPickupInfo = this.props.strings.Job.form.pickupInfo;
    const baseTask = this.props.data.base_task || { address: {} };
    const time = Utils.Formatter.getInlineRangeDateTime(baseTask.time_from,
      baseTask.time_to).split(', ');

    return (
      <div className="vf-job__detail">
        <Components.Form.MobileMainHeader
          iconClassName={this.props.data.job_type === 'pickup' ? 'versa-base-pickup'
            : 'versa-base-delivery'}
          iconText=""
          status={this.props.strings.Job.status[this.props.data.state]}
          statusIcon={getStatusIcon(this.props.data)}
          text={this.props.data.job_type === 'pickup' ? stringsPickupInfo.deliveryTo
            : stringsPickupInfo.pickupFrom}
        />
        <Components.Form.Block fontWeight="BOLD" level={1}>
          {this.props.data.customer.name}
          <br />
          {this.props.data.guid}
        </Components.Form.Block>
        <Components.Form.Divider />
        <Components.Form.Block iconClassName="versa-contact" level={1}>
          {Utils.Helper.isNonEmptyString(baseTask.address.contact_person)
            ? [baseTask.address.contact_person, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.contact_number)
            ? [baseTask.address.contact_number, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.email)
            ? baseTask.address.email : false}
        </Components.Form.Block>
        <Components.Form.Divider />
        <Components.Form.Block iconClassName="versa-marker-plain" iconText="" level={1}>
          {Utils.Helper.isNonEmptyString(baseTask.address.name)
            ? [baseTask.address.name, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.line_1)
            ? [baseTask.address.line_1, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.line_2)
            ? [baseTask.address.line_2, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.city)
            ? [baseTask.address.city, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.zip)
            ? [baseTask.address.zip, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.country)
            ? baseTask.address.country : false}
        </Components.Form.Block>
        <Components.Form.Divider />
        <Components.Form.Block iconClassName="versa-calendar-day" iconText="" level={1}>
          {moment(baseTask.time_from).format('DD MMM YYYY')}
        </Components.Form.Block>
        <Components.Form.Divider />
        <Components.Form.Block iconClassName="versa-timelapse" iconText="" level={1}>
          {time[0]}
        </Components.Form.Block>

        <Components.Form.Divider size="LARGE" />

        {/* Additional Info */}

        {this._renderAdditionalInfo()}
        <Components.Form.Divider />

        {/* Task Info */}

        <div className="vf-job__detail__tasks">
          {`${this.props.data.job_type === 'delivery' ? this.props.strings.Job.form.task.deliveryTask
            : this.props.strings.Job.form.task.pickupTask} (${(this.props.data.tasks || []).length})`}
          {allowAddTask(this.props.data) ? (
            <Components.Button
              className="vf-job__detail__tasks__button-add"
              iconClassName="versa-add"
              onClick={() => { Utils.Router.transitionFromSubpath('jobs', `${this.props.data.id}/new_task`); }}
            >
              {this.props.strings.Job.form.buttons.addTask}
            </Components.Button>
          ) : false}

        </div>

        {(this.props.data.tasks || []).map((t, i) => (
          <div className="vf-job__detail__task-item">
            <div className="vf-job__detail__task-item__index">
              {`${i + 1}.`}
            </div>
            <div
              className="vf-job__detail__task-item__content"
              id={`${this.props.id}__task-item-redirect`}
              onClick={() => this._routeToTaskDetails(t.id)}
            >
              <div className="vf-job__detail__task-item__content__name">
                {(t.billing_account || {}).name || this.props.strings.Task.form.constants.noAccount}
              </div>
              <div className="vf-job__detail__task-item__content__guid">
                {t.guid}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

JobDetail.propTypes = {
  data: PropTypes.shape({
    attachments: PropTypes.arrayOf(PropTypes.shape()),
    base_task: PropTypes.shape({
      address: PropTypes.shape({
        name: PropTypes.string,
        line_1: PropTypes.string,
        line_2: PropTypes.string,
        city: PropTypes.string,
        zip: PropTypes.string,
        country: PropTypes.string,
        contact_person: PropTypes.string,
        contact_number: PropTypes.string,
        email: PropTypes.string,
      }),
      time_from: PropTypes.string,
      time_to: PropTypes.string,
    }),
    customer: PropTypes.shape({
      name: PropTypes.string,
    }),
    guid: PropTypes.string,
    id: PropTypes.number,
    job_type: PropTypes.string,
    remarks: PropTypes.string,
    state: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
    tasks: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      billing_account: PropTypes.shape({
        name: PropTypes.string,
      }),
      guid: PropTypes.string,
    })),
    time_from: PropTypes.string,
  }),
  id: PropTypes.string,
  myjobsSetting: PropTypes.shape({
    show_additional_info: PropTypes.bool,
    show_note: PropTypes.bool,
    show_tags: PropTypes.bool,
  }).isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      form: PropTypes.shape({
        additionalInfo: PropTypes.shape({
          title: PropTypes.string,
          noRemarks: PropTypes.string,
        }),
        buttons: PropTypes.shape({
          addTask: PropTypes.string,
        }),
        pickupInfo: PropTypes.shape({
          deliveryTo: PropTypes.string,
          pickupFrom: PropTypes.string,
        }),
        task: PropTypes.shape({
          deliveryTask: PropTypes.string,
          pickupTask: PropTypes.string,
        }),
      }),
      status: PropTypes.shape(),
    }),
    Task: PropTypes.shape({
      form: PropTypes.shape({
        constants: PropTypes.shape({
          noAccount: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

JobDetail.defaultProps = {
  data: {},
  id: 'vf-job__detail',
};

const mapStateToProps = (state) => {
  const { profile } = state;
  return {
    myjobsSetting: (profile.profile || {}).myjobs_setting,
  };
};

export default connect(mapStateToProps)(translate('')(JobDetail));
